import styled from 'styled-components';
import PerfectScrollbar from 'react-perfect-scrollbar';
import './scrollbar.css';

export const Scrollbar = styled(PerfectScrollbar)`
  background-color: ${(props) => props.theme.sidebar.background};
  border-right: 1px solid rgba(0, 0, 0, 0.12);
`;
